import { YEARS as YEAR_VALUES, DIVISIONS as DIVISION_VALUES } from "./constants";

export const DATA_TYPES = [
  { id: "scoreboard", label: "Scoreboard" },
  { id: "player_batting", label: "Player Batting" },
  { id: "player_pitching", label: "Player Pitching" },
  { id: "team_batting", label: "Team Batting" },
  { id: "team_pitching", label: "Team Pitching" },
  { id: "guts", label: "Guts" },
  { id: "park_factors", label: "Park Factors" },
  { id: "expected_runs", label: "Expected Runs" },
  { id: "value", label: "Value" },
  { id: "situational", label: "Situational" },
  { id: "baserunning", label: "Baserunning" },
  { id: "splits", label: "Splits" },
  { id: "battedball", label: "Batted Ball" },
  { id: "rolling", label: "Rolling" },
];

export const DIVISIONS = DIVISION_VALUES.map(d => ({
  label: `Division ${d}`,
  value: d,
}));

export const YEARS = YEAR_VALUES;

export const DATA_TYPE_CONFIG = {
  scoreboard: {
    hasYears: false,
    hasDate: true,
    hasSearch: false,
    hasConference: false,
    hasDivision: true,
    hasPlayerList: false,
    hasApplyFilters: false,
    searchPlaceholder: "",
    yearLabel: "",
    multiYear: false,
    dateLabel: "Date:",
  },
  player_batting: {
    hasYears: true,
    hasDate: false,
    hasSearch: true,
    hasConference: true,
    hasDivision: true,
    hasPlayerList: true,
    hasApplyFilters: true,
    searchPlaceholder: "Search players or teams...",
    canAddToPlayerList: true,
    yearLabel: "Years to include:",
    multiYear: true,
    minFilters: {
      all: { key: "minPA", label: "Min PA" },
    },
  },
  player_pitching: {
    hasYears: true,
    hasDate: false,
    hasSearch: true,
    hasConference: true,
    hasDivision: true,
    hasPlayerList: true,
    hasApplyFilters: true,
    canAddToPlayerList: true,
    searchPlaceholder: "Search players or teams...",
    yearLabel: "Years to include:",
    multiYear: true,
    minFilters: {
      all: { key: "minIP", label: "Min IP" },
    },
  },
  team_batting: {
    hasYears: true,
    hasDate: false,
    hasSearch: true,
    hasConference: true,
    hasDivision: true,
    hasApplyFilters: true,
    searchPlaceholder: "Search teams...",
    yearLabel: "Years to include:",
    multiYear: true,
  },
  team_pitching: {
    hasYears: true,
    hasDate: false,
    hasSearch: true,
    hasConference: true,
    hasDivision: true,
    hasApplyFilters: true,
    searchPlaceholder: "Search teams...",
    yearLabel: "Years to include:",
    multiYear: true,
  },
  guts: {
    hasYears: true,
    hasDate: false,
    hasSearch: false,
    hasConference: false,
    hasDivision: false,
    hasApplyFilters: false,
    searchPlaceholder: "",
    yearLabel: "Year:",
    multiYear: false,
  },
  park_factors: {
    hasYears: false,
    hasDate: false,
    hasSearch: true,
    hasConference: true,
    hasDivision: true,
    hasPlayerList: false,
    hasApplyFilters: false,
    searchPlaceholder: "Search teams...",
    yearLabel: "",
    multiYear: false,
  },
  expected_runs: {
    hasYears: true,
    hasDate: false,
    hasSearch: false,
    hasConference: false,
    hasDivision: true,
    hasApplyFilters: false,
    searchPlaceholder: "",
    yearLabel: "Year:",
    multiYear: false,
  },
  value: {
    hasYears: true,
    hasDate: false,
    hasSearch: true,
    hasConference: true,
    hasDivision: true,
    hasPlayerList: true,
    hasPlayerType: true,
    hasViewLevel: true,
    hasApplyFilters: true,
    searchPlaceholder: "Search players or teams...",
    yearLabel: "Years to include:",
    multiYear: true,
    minFilters: {
      batter: { key: "minPA", label: "Min PA" },
      pitcher: { key: "minIP", label: "Min IP" },
    },
  },
  situational: {
    hasYears: true,
    hasDate: false,
    hasSearch: true,
    hasConference: true,
    hasDivision: true,
    hasPlayerList: true,
    hasPlayerType: true,
    hasViewLevel: true,
    hasApplyFilters: true,
    searchPlaceholder: "Search players or teams...",
    yearLabel: "Years to include:",
    multiYear: true,
    minFilters: {
      batter: { key: "minPA", label: "Min PA" },
      pitcher: { key: "minBF", label: "Min BF" },
    },
  },
  baserunning: {
    hasYears: true,
    hasDate: false,
    hasSearch: true,
    hasConference: true,
    hasDivision: true,
    hasPlayerList: true,
    hasViewLevel: true,
    hasApplyFilters: true,
    searchPlaceholder: "Search players or teams...",
    yearLabel: "Years to include:",
    multiYear: true,
  },
  splits: {
    hasYears: true,
    hasDate: false,
    hasSearch: true,
    hasConference: true,
    hasDivision: true,
    hasPlayerList: true,
    hasPlayerType: true,
    hasViewLevel: true,
    hasApplyFilters: true,
    searchPlaceholder: "Search players or teams...",
    yearLabel: "Years to include:",
    multiYear: true,
    minFilters: {
      batter: { key: "minPA", label: "Min PA" },
      pitcher: { key: "minBF", label: "Min BF" },
    },
  },
  battedball: {
    hasYears: true,
    hasDate: false,
    hasSearch: true,
    hasConference: true,
    hasDivision: true,
    hasPlayerList: true,
    hasPlayerType: true,
    hasViewLevel: true,
    hasApplyFilters: true,
    searchPlaceholder: "Search players or teams...",
    yearLabel: "Years to include:",
    multiYear: true,
    minFilters: {
      all: { key: "minPA", label: "Min Batted Balls" },
    },
  },
  rolling: {
    hasYears: true,
    hasDate: false,
    hasSearch: true,
    hasConference: true,
    hasDivision: true,
    hasPlayerList: true,
    hasPlayerType: true,
    hasApplyFilters: true,
    searchPlaceholder: "Search players or teams...",
    yearLabel: "Years to include:",
    multiYear: true,
  },
};

export const getDataTypeConfig = (type) => {
  return DATA_TYPE_CONFIG[type] || DATA_TYPE_CONFIG.player_batting;
};
